import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

function GizlilikPolitikasi() {
  return (
    <Container maxWidth="md" sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Gizlilik Politikası
        </Typography>

        <Typography paragraph>
          KAYLA BUTİK olarak kişisel verilerinizin güvenliği konusunda azami hassasiyet göstermekteyiz.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Kişisel Verilerin Korunması
        </Typography>
        <Typography paragraph>
          Web sitemizi ziyaret ettiğinizde ve alışveriş yaptığınızda, size daha iyi hizmet verebilmek için bazı kişisel bilgilerinizi (isim, adres, telefon, e-posta vb.) sizlerden talep etmekteyiz. Bu bilgiler sadece siparişlerinizin işleme alınması ve sizinle iletişime geçilmesi amacıyla kullanılmaktadır.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Bilgi Güvenliği
        </Typography>
        <Typography paragraph>
          Sitemizde girdiğiniz tüm bilgiler SSL sertifikası ile şifrelenerek korunmaktadır. Kredi kartı bilgileriniz kesinlikle kaydedilmemekte ve saklanmamaktadır.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Çerez Politikası
        </Typography>
        <Typography paragraph>
          Web sitemiz, deneyiminizi geliştirmek için çerezler kullanmaktadır. Bu çerezler, sitede gezinme tercihlerinizi hatırlamak ve size daha kişiselleştirilmiş bir deneyim sunmak için kullanılmaktadır.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Bilgi Paylaşımı
        </Typography>
        <Typography paragraph>
          Kişisel bilgileriniz, yasal zorunluluklar dışında, kesinlikle üçüncü şahıslarla paylaşılmamaktadır. Bu bilgiler sadece sipariş teslimatı ve müşteri hizmetleri amacıyla kullanılmaktadır.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İletişim İzinleri
        </Typography>
        <Typography paragraph>
          Kampanya ve yeniliklerden haberdar olmak için verdiğiniz iletişim izinlerini dilediğiniz zaman geri çekebilirsiniz. Bunun için müşteri hizmetlerimiz ile iletişime geçebilirsiniz.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          İletişim
        </Typography>
        <Typography paragraph>
          Gizlilik politikamız hakkında sorularınız için:
          <br />
          E-posta: info@kaylabutik.com
          <br />
          Telefon: +90 (531) 694 97 44
        </Typography>
      </Paper>
    </Container>
  );
}

export default GizlilikPolitikasi; 